/************************************
MODULE:         FIX ELEMENTS ON SCROLL
WHAT IT DOES:   Contains functionality for different sticky blocks on the site
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var bottomFixElements,
        topFixElements,
        topFixHelpers,
        isNativeKeyboardOpened,
        homeinput = $('.js-home-banner .js-search-store-input'),
        isIOS;

function init() {

        if ( ($('body').hasClass('fixed-scrolls-canceled'))  && (!($('body').hasClass('is-find-a-store')))) {
            return;
        }

        isMobileDevice = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("android") > -1 || $('html').hasClass('windows-mobile');
        initFixOnScrolls();
        $(window).on('fixonscroll:reinit', initFixOnScrolls);
        $(window).on('fixonscroll:destroy', destroyFixOnScrolls);
        $(window).on('fixonscroll:allow', allowFixOnScrolls);
    }

    function initFixOnScrolls() {
        initBottomFixOnScrolls();
        initTopFixOnScrolls();
    }

    function destroyFixOnScrolls() {
        destroyBottomFixOnScrolls();
        destroyTopFixOnScrolls();

        $('.js-bottom-fix-on-scroll').removeClass('is-fixed');
        $('html').removeClass('top-fix-is-fixed');
    }

    function allowFixOnScrolls() {
        $('body').removeClass('fixed-scrolls-canceled');
        initFixOnScrolls();
    }

    function assignFixers(elements, functionName, shouldntCallFunctionByDefault) {
        deassignFixers(functionName);

        if (!elements.length) {
            return;
        }

        window.App.globals.onScrollElement.on('scroll', functionName);
        $(window).on('touchmove', functionName);
        $(window).on('resize:finished', functionName);
        $(window).on('fixed:update', functionName);
        homeinput.on('blur', functionName);

        if (!shouldntCallFunctionByDefault) {
            functionName();
        }
    }

    function deassignFixers(functionName) {
        window.App.globals.onScrollElement.off('scroll', functionName);
        $(window).off('touchmove', functionName);
        $(window).off('resize:finished', functionName);
        $(window).off('fixed:update', functionName);
        homeinput.off('blur', functionName);
    }

    //bottom fixers
    function initBottomFixOnScrolls() {
        bottomFixElements = $('.js-bottom-fix-on-scroll');
        assignFixers(bottomFixElements, bottomFixOnScroll);
    }

    function destroyBottomFixOnScrolls() {
        deassignFixers(bottomFixOnScroll);
    }

    function bottomFixOnScroll() {
        if (!window.App.globals.isMobileSmall)
            return;
        var scrollTop = window.App.globals.getTop();

        for (var i = 0, l = bottomFixElements.length; i < l; i++) {
            var bottomFixElement = bottomFixElements.eq(i),
                top = bottomFixElement.offset().top + (window.App.globals.isCustomScroll ? scrollTop : 0),
                height = bottomFixElement.outerHeight(),
                bottom = top + height,
                bottommin = bottomFixElement.parents('.tab_single').offset().top + (window.App.globals.isCustomScroll ? scrollTop : 0) + height,
                screenhei = Math.max(window.App.globals.height, bottomFixElement.children('.js-bottom-fix-on-scroll-helper').outerHeight());

            var isFixed = bottomFixElement.is(':visible') &&
                scrollTop + screenhei > bottommin &&
                scrollTop + screenhei < bottom;

            bottomFixElement[isFixed ? "addClass" : "removeClass"]('is-fixed');
        }
    }

    //top fixers

    function initTopFixOnScrolls() {
        //we won't assume anymore there can be a single element per page
        allTopFixHelpers = $('.js-top-fixed');

        if (allTopFixHelpers.length)
        {
            topfixHelper = allTopFixHelpers.first();
            allTopFixHelpers.removeClass('maybe-top-fixed');

            if (topfixHelper.parent().hasClass('js-top-fix-on-scroll')) {
                allTopFixHelpers.first().addClass('maybe-top-fixed');
            }

            topFixElements = $('.js-top-fix-on-scroll');
            assignFixers(topFixElements, topFixOnScroll);
        }
    }

    function destroyTopFixOnScrolls() {
        deassignFixers(topFixOnScroll);
    }

    function topFixOnScroll() {
        var scrollTop = window.App.globals.getTop();
        for (var i = 0, l = Math.min(topFixElements.length, topfixHelper.length); i < l; i++) {
            var top = topFixElements.eq(i).offset().top + (window.App.globals.isCustomScroll ? scrollTop : 0) - parseInt(topfixHelper.eq(i).css('padding-top'));

            $('html')[scrollTop > top && !(isMobileDevice && homeinput.is(':focus')) ? "addClass" : "removeClass"]('top-fix-is-fixed');
            topfixHelper.eq(i)[scrollTop > top && !(isMobileDevice && homeinput.is(':focus')) ? "addClass" : "removeClass"]('top-fixed');
        }
    }

    return {
        init: init,
        assignFixers: assignFixers,
        deassignFixers: deassignFixers
    };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.fixedonscroll.js
 ** module id = 40
 ** module chunks = 24
 **/